/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { useEffect, useState } from "react";

import { Agree } from "@vienna/prisma";

import { ButtonAndStatsContainer, RightAlignedStats } from "src/components/Splash/styles";
import { ButtonWithLoading } from "src/components/UI/Buttons/ButtonWithLoading";

export const fetchAgreeStats = async (title: string) => {
  try {
    const res = await fetch(
      `/api/agree?${new URLSearchParams({
        title,
      })}`,
      {
        method: "GET",
      }
    );
    const data = res.json();
    return await data;
  } catch (error) {
    // console.error(error);
  }
};

export const increaseAgreeCount = async (title: string) => {
  try {
    const res = await fetch("/api/agree", {
      method: "POST",
      body: JSON.stringify({ title: title }),
    });
    const data = res.json();
    return await data;
  } catch (error) {
    // console.error(error);
  }
};

interface Props {
  title: string;
  buttonText: string;
  tableText: string;
  buttonWidth: string;
}

export const GenericAgreeStats = ({ title, buttonText, tableText, buttonWidth }: Props) => {
  const [stats, setStats] = useState<Agree | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAgreeStats(title).then((someStats: any) => {
      setStats(someStats);
      setLoading(false);
    });
  }, [title]);

  const handleQuotaIncrease = async () => {
    setLoading(true);
    const newQuota = await increaseAgreeCount(title);
    setStats(newQuota);
    setLoading(false);
  };

  return (
    <ButtonAndStatsContainer>
      <ButtonWithLoading handleClick={handleQuotaIncrease} loading={loading} width={buttonWidth}>
        {buttonText}
      </ButtonWithLoading>
      <RightAlignedStats>
        <table className="tg">
          <tbody>
            <tr>
              <th className="tg"> {tableText}</th>
              <td className="tg">{stats ? stats.agreeCount : "λ"}</td>
            </tr>
          </tbody>
        </table>
      </RightAlignedStats>
    </ButtonAndStatsContainer>
  );
};
